import { filterTime, handlePlanType } from '@/utils'
// 表格项
export const columns = [
  {
    title: '就诊人ID',
    dataIndex: 'ucPatientId',
    key: 'ucPatientId',
    width: 120,
    ellipsis: true,
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileId || '--'
    }
  },
  {
    title: '就诊人姓名',
    dataIndex: 'patientName',
    key: 'patientName',
    width: 180,
    ellipsis: true,
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileName || '--'
    }
  },
  {
    title: '计划名称',
    dataIndex: 'planName',
    key: 'planName',
    width: 180,
    ellipsis: true,
    slots: { customRender: 'planName' }
  },
  {
    title: '随访类型',
    dataIndex: 'planType',
    key: 'planType',
    width: 100,
    customRender: ({ text }) => handlePlanType(text)
  },
  {
    title: '关联处方',
    dataIndex: 'relevancyPrescriptions',
    key: 'relevancyPrescriptions',
    width: 220,
    slots: { customRender: 'relevancyPrescriptions' }
  },
  {
    title: '随访状态',
    dataIndex: 'planStatus',
    key: 'planStatus',
    width: 100,
    ellipsis: true,
    // 0：未开始 1：进行中 2：已结束 3: 已取消
    customRender: ({ text }) => {
      const status = ['未开始', '进行中', '已结束', '已取消']
      const ans = status[text]
      return ans
    }
  },
  {
    title: '开始时间',
    dataIndex: 'beginTime',
    key: 'beginTime',
    width: 120,
    customRender: filterTime
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    width: 120,
    customRender: filterTime
  },
  {
    title: '医生ID',
    dataIndex: 'doctorId',
    key: 'doctorId',
    width: 100
  },
  {
    title: '医生姓名',
    dataIndex: 'doctorName',
    key: 'doctorName',
    width: 100,
    ellipsis: true
  },
  {
    title: '随访ID',
    dataIndex: 'followupPlanId',
    key: 'followupPlanId',
    width: 150
  },
  {
    title: '操作',
    key: 'handle',
    width: 100,
    dataIndex: 'handle',
    slots: { customRender: 'handle' },
    fixed: 'right'
  }
]
// 查询条件 0：未开始 1：进行中 2：已结束 3: 已取消
export const condition = [
  {
    label: '全部',
    value: null
  },
  {
    label: '未开始',
    value: 0
  },
  {
    label: '进行中',
    value: 1
  },
  {
    label: '已结束',
    value: 2
  },
  {
    label: '已取消',
    value: 3
  }
]
export const TagType = {
  medication: 1, // 用药计划
  visit: 2 // 随访
}
// 平台的条件改为新版数据和历史数据
export const platformCondition = [
  {
    label: '新版数据',
    value: TagType.medication
  },
  {
    label: '历史数据',
    value: TagType.visit
  }
]
export const visitType = [
  {
    label: '平台',
    value: 0,
    condition: platformCondition
  },
  {
    label: '临观',
    value: 1,
    condition
  },
  {
    label: '医生',
    value: 2,
    condition
  }
]
